import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { knmSetLegalEntityData } from '../actions/knmActions';
import { IKnmStateLegalEntityData } from '../types/IKnmState';

export function useKnmSetLegalEntityDataAction() {
  const dispatch = useDispatch();
  const dispatchKnmSetLegalEntityData = useCallback(
    (data: IKnmStateLegalEntityData | undefined) => dispatch(knmSetLegalEntityData(data)),
    [dispatch],
  );

  return { dispatchKnmSetLegalEntityData };
}
